/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptRequest,
  Accepted,
  Detail,
  LogoutRequest,
  Me,
  OTPRequestRequest,
  OTPVerifyRequest,
  PatchedMeRequest,
  RefreshRequestRequest,
  TokenPair,
  TokenRefreshResponse
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Public: the secret link opens the access once and signs the person in.
 */
export type authInvitationAcceptCreateResponse200 = {
  data: Accepted
  status: 200
}
    
export type authInvitationAcceptCreateResponseSuccess = (authInvitationAcceptCreateResponse200) & {
  headers: Headers;
};
;

export type authInvitationAcceptCreateResponse = (authInvitationAcceptCreateResponseSuccess)

export const getAuthInvitationAcceptCreateUrl = () => {


  

  return `/api/v1/auth/invitation/accept/`
}

export const authInvitationAcceptCreate = async (acceptRequest: AcceptRequest, options?: RequestInit): Promise<authInvitationAcceptCreateResponse> => {
  
  return apiFetch<authInvitationAcceptCreateResponse>(getAuthInvitationAcceptCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      acceptRequest,)
  }
);}




export const getAuthInvitationAcceptCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authInvitationAcceptCreate>>, TError,{data: AcceptRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authInvitationAcceptCreate>>, TError,{data: AcceptRequest}, TContext> => {

const mutationKey = ['authInvitationAcceptCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authInvitationAcceptCreate>>, {data: AcceptRequest}> = (props) => {
          const {data} = props ?? {};

          return  authInvitationAcceptCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthInvitationAcceptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authInvitationAcceptCreate>>>
    export type AuthInvitationAcceptCreateMutationBody = AcceptRequest
    export type AuthInvitationAcceptCreateMutationError = unknown

    export const useAuthInvitationAcceptCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authInvitationAcceptCreate>>, TError,{data: AcceptRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authInvitationAcceptCreate>>,
        TError,
        {data: AcceptRequest},
        TContext
      > => {

      const mutationOptions = getAuthInvitationAcceptCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Revokes the refresh token (it can never be used again) and clears the web cookie.
 */
export type authLogoutCreateResponse205 = {
  data: void
  status: 205
}
    
export type authLogoutCreateResponseSuccess = (authLogoutCreateResponse205) & {
  headers: Headers;
};
;

export type authLogoutCreateResponse = (authLogoutCreateResponseSuccess)

export const getAuthLogoutCreateUrl = () => {


  

  return `/api/v1/auth/logout/`
}

export const authLogoutCreate = async (logoutRequest: LogoutRequest, options?: RequestInit): Promise<authLogoutCreateResponse> => {
  
  return apiFetch<authLogoutCreateResponse>(getAuthLogoutCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      logoutRequest,)
  }
);}




export const getAuthLogoutCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogoutCreate>>, TError,{data: LogoutRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogoutCreate>>, TError,{data: LogoutRequest}, TContext> => {

const mutationKey = ['authLogoutCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogoutCreate>>, {data: LogoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  authLogoutCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authLogoutCreate>>>
    export type AuthLogoutCreateMutationBody = LogoutRequest
    export type AuthLogoutCreateMutationError = unknown

    export const useAuthLogoutCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogoutCreate>>, TError,{data: LogoutRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogoutCreate>>,
        TError,
        {data: LogoutRequest},
        TContext
      > => {

      const mutationOptions = getAuthLogoutCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in person: language and theme are remembered on the account (P0-03, P0-08).
 */
export type authMeRetrieveResponse200 = {
  data: Me
  status: 200
}
    
export type authMeRetrieveResponseSuccess = (authMeRetrieveResponse200) & {
  headers: Headers;
};
;

export type authMeRetrieveResponse = (authMeRetrieveResponseSuccess)

export const getAuthMeRetrieveUrl = () => {


  

  return `/api/v1/auth/me/`
}

export const authMeRetrieve = async ( options?: RequestInit): Promise<authMeRetrieveResponse> => {
  
  return apiFetch<authMeRetrieveResponse>(getAuthMeRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAuthMeRetrieveQueryKey = () => {
    return [
    `/api/v1/auth/me/`
    ] as const;
    }

    
export const getAuthMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof authMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMeRetrieve>>> = ({ signal }) => authMeRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof authMeRetrieve>>>
export type AuthMeRetrieveQueryError = unknown


export function useAuthMeRetrieve<TData = Awaited<ReturnType<typeof authMeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMeRetrieve<TData = Awaited<ReturnType<typeof authMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMeRetrieve<TData = Awaited<ReturnType<typeof authMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthMeRetrieve<TData = Awaited<ReturnType<typeof authMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in person: language and theme are remembered on the account (P0-03, P0-08).
 */
export type authMePartialUpdateResponse200 = {
  data: Me
  status: 200
}
    
export type authMePartialUpdateResponseSuccess = (authMePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type authMePartialUpdateResponse = (authMePartialUpdateResponseSuccess)

export const getAuthMePartialUpdateUrl = () => {


  

  return `/api/v1/auth/me/`
}

export const authMePartialUpdate = async (patchedMeRequest: PatchedMeRequest, options?: RequestInit): Promise<authMePartialUpdateResponse> => {
  
  return apiFetch<authMePartialUpdateResponse>(getAuthMePartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedMeRequest,)
  }
);}




export const getAuthMePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authMePartialUpdate>>, TError,{data: PatchedMeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authMePartialUpdate>>, TError,{data: PatchedMeRequest}, TContext> => {

const mutationKey = ['authMePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authMePartialUpdate>>, {data: PatchedMeRequest}> = (props) => {
          const {data} = props ?? {};

          return  authMePartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthMePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof authMePartialUpdate>>>
    export type AuthMePartialUpdateMutationBody = PatchedMeRequest
    export type AuthMePartialUpdateMutationError = unknown

    export const useAuthMePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authMePartialUpdate>>, TError,{data: PatchedMeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authMePartialUpdate>>,
        TError,
        {data: PatchedMeRequest},
        TContext
      > => {

      const mutationOptions = getAuthMePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type authOtpRequestCreateResponse202 = {
  data: Detail
  status: 202
}

export type authOtpRequestCreateResponse400 = {
  data: Detail
  status: 400
}

export type authOtpRequestCreateResponse429 = {
  data: Detail
  status: 429
}
    
export type authOtpRequestCreateResponseSuccess = (authOtpRequestCreateResponse202) & {
  headers: Headers;
};
export type authOtpRequestCreateResponseError = (authOtpRequestCreateResponse400 | authOtpRequestCreateResponse429) & {
  headers: Headers;
};

export type authOtpRequestCreateResponse = (authOtpRequestCreateResponseSuccess | authOtpRequestCreateResponseError)

export const getAuthOtpRequestCreateUrl = () => {


  

  return `/api/v1/auth/otp/request/`
}

export const authOtpRequestCreate = async (oTPRequestRequest: OTPRequestRequest, options?: RequestInit): Promise<authOtpRequestCreateResponse> => {
  
  return apiFetch<authOtpRequestCreateResponse>(getAuthOtpRequestCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTPRequestRequest,)
  }
);}




export const getAuthOtpRequestCreateMutationOptions = <TError = Detail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpRequestCreate>>, TError,{data: OTPRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authOtpRequestCreate>>, TError,{data: OTPRequestRequest}, TContext> => {

const mutationKey = ['authOtpRequestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authOtpRequestCreate>>, {data: OTPRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  authOtpRequestCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthOtpRequestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authOtpRequestCreate>>>
    export type AuthOtpRequestCreateMutationBody = OTPRequestRequest
    export type AuthOtpRequestCreateMutationError = Detail

    export const useAuthOtpRequestCreate = <TError = Detail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpRequestCreate>>, TError,{data: OTPRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authOtpRequestCreate>>,
        TError,
        {data: OTPRequestRequest},
        TContext
      > => {

      const mutationOptions = getAuthOtpRequestCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type authOtpVerifyCreateResponse200 = {
  data: TokenPair
  status: 200
}

export type authOtpVerifyCreateResponse400 = {
  data: Detail
  status: 400
}

export type authOtpVerifyCreateResponse429 = {
  data: Detail
  status: 429
}
    
export type authOtpVerifyCreateResponseSuccess = (authOtpVerifyCreateResponse200) & {
  headers: Headers;
};
export type authOtpVerifyCreateResponseError = (authOtpVerifyCreateResponse400 | authOtpVerifyCreateResponse429) & {
  headers: Headers;
};

export type authOtpVerifyCreateResponse = (authOtpVerifyCreateResponseSuccess | authOtpVerifyCreateResponseError)

export const getAuthOtpVerifyCreateUrl = () => {


  

  return `/api/v1/auth/otp/verify/`
}

export const authOtpVerifyCreate = async (oTPVerifyRequest: OTPVerifyRequest, options?: RequestInit): Promise<authOtpVerifyCreateResponse> => {
  
  return apiFetch<authOtpVerifyCreateResponse>(getAuthOtpVerifyCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTPVerifyRequest,)
  }
);}




export const getAuthOtpVerifyCreateMutationOptions = <TError = Detail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpVerifyCreate>>, TError,{data: OTPVerifyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authOtpVerifyCreate>>, TError,{data: OTPVerifyRequest}, TContext> => {

const mutationKey = ['authOtpVerifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authOtpVerifyCreate>>, {data: OTPVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  authOtpVerifyCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthOtpVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authOtpVerifyCreate>>>
    export type AuthOtpVerifyCreateMutationBody = OTPVerifyRequest
    export type AuthOtpVerifyCreateMutationError = Detail

    export const useAuthOtpVerifyCreate = <TError = Detail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpVerifyCreate>>, TError,{data: OTPVerifyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authOtpVerifyCreate>>,
        TError,
        {data: OTPVerifyRequest},
        TContext
      > => {

      const mutationOptions = getAuthOtpVerifyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * New access token. The refresh token comes from the body (mobile) or the cookie (web).
 */
export type authTokenRefreshCreateResponse200 = {
  data: TokenRefreshResponse
  status: 200
}

export type authTokenRefreshCreateResponse401 = {
  data: Detail
  status: 401
}
    
export type authTokenRefreshCreateResponseSuccess = (authTokenRefreshCreateResponse200) & {
  headers: Headers;
};
export type authTokenRefreshCreateResponseError = (authTokenRefreshCreateResponse401) & {
  headers: Headers;
};

export type authTokenRefreshCreateResponse = (authTokenRefreshCreateResponseSuccess | authTokenRefreshCreateResponseError)

export const getAuthTokenRefreshCreateUrl = () => {


  

  return `/api/v1/auth/token/refresh/`
}

export const authTokenRefreshCreate = async (refreshRequestRequest: RefreshRequestRequest, options?: RequestInit): Promise<authTokenRefreshCreateResponse> => {
  
  return apiFetch<authTokenRefreshCreateResponse>(getAuthTokenRefreshCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshRequestRequest,)
  }
);}




export const getAuthTokenRefreshCreateMutationOptions = <TError = Detail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authTokenRefreshCreate>>, TError,{data: RefreshRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authTokenRefreshCreate>>, TError,{data: RefreshRequestRequest}, TContext> => {

const mutationKey = ['authTokenRefreshCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authTokenRefreshCreate>>, {data: RefreshRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  authTokenRefreshCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthTokenRefreshCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authTokenRefreshCreate>>>
    export type AuthTokenRefreshCreateMutationBody = RefreshRequestRequest
    export type AuthTokenRefreshCreateMutationError = Detail

    export const useAuthTokenRefreshCreate = <TError = Detail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authTokenRefreshCreate>>, TError,{data: RefreshRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authTokenRefreshCreate>>,
        TError,
        {data: RefreshRequestRequest},
        TContext
      > => {

      const mutationOptions = getAuthTokenRefreshCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    